import moment from 'moment';
import { useDispatch } from 'react-redux';
import { Entypo } from '@expo/vector-icons';
import React, { useEffect, useState } from 'react';
import { Text, TouchableOpacity, View, Image, Linking } from 'react-native';
import FilePicker from '../../commonComponents/filePicker/filepicker.web';
import { ODSText } from '../../../openbrix-design-system/ui/atoms/ODSText';
import ODSdocumentCard from '../../../openbrix-design-system/ui/molecules/propertyBox/ODSdocumentCard';
import RequestDocs from '../openFlow/molecules/requestDocs';
import { tenantActions } from '../openFlow/openFlowRedux/tenant.actions';
import ODSButton from '../../../openbrix-design-system/ui/atoms/ODSButton/index.web';
import { getFullReferencingVerificationStatus } from '../openFlow/helpers';
import getPlatformType from '../../helpers/getPlatform';
import { COLORS } from '../../constants/colorPallete';
import { LineSaperator,BoxShadow } from '../tds/style';
import { MainSection, Typography } from '../openFlow/style';
import ODSBadges from '../../../openbrix-design-system/ui/atoms/ODSBadges';
import { useTheme } from '@emotion/react';
import { ODSModal } from '../../../openbrix-design-system/ui/atoms/ODSModal/ODSModal.web';
import { ODSIcon } from '../../../openbrix-design-system/ui/atoms/ODSIcon';

const layoutType = getPlatformType();

export const AccordianCard = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };
  const { title, status, comments, lastUpdate } = props;
  const getStatus = (status) => {
    switch (status) {
      case 'COMPLETE':
        return {
          uri: require('./completed.png'),
          styles: { width: 20, height: 20 },
        };
        break;
      case 'NOT STARTED':
        return {
          uri: require('./notStarted.png'),
          styles: { width: 20, height: 20 },
        };
        break;
      case 'N/A':
        return {
          uri: require('./notStarted.png'),
          styles: { width: 20, height: 20 },
        };
        break;
      case 'PENDING':
        return {
          uri: require('./inProgress.png'),
          styles: { width: 20, height: 20 },
        };
        break;
      default:
        return {
          uri: require('./inProgress.png'),
          styles: { width: 20, height: 20 },
        };
        break;
    }
  };

  return (
    <React.Fragment>
      <LineSaperator color={'#D9D9D9'} />
      <View style={{ flexDirection: 'row', height: 70 }}>
        <View
          style={{
            flex: 0.3,
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Image
            source={getStatus(status).uri}
            resizeMode="contain"
            style={getStatus(status.toProperCase()).styles}
          />
          <ODSText marginTop={6} type={'xs'}>
            {status.toProperCase()}
          </ODSText>
        </View>
        <View style={{ flex: 0.5, justifyContent: 'center' }}>
          <ODSText marginTop={6} marginLeft={6} type={'md'}>
            {title}
          </ODSText>
        </View>
        <TouchableOpacity
          onPress={() => {
            setIsOpen(!isOpen);
          }}
          style={{ flex: 0.2, justifyContent: 'center', alignItems: 'center' }}
        >
          <Entypo name={isOpen ? 'chevron-up' : 'chevron-down'} size={23} color={COLORS.LGREEN} />
        </TouchableOpacity>
      </View>
      {isOpen ? (
        <View style={{ marginHorizontal: 25 }}>
          <ODSText marginTop={16} type={'button'}>
            Status
          </ODSText>
          <ODSText marginTop={6} type={'sm'}>
            {status.toProperCase()}
          </ODSText>

          <ODSText marginTop={16} type={'button'}>
            Comments
          </ODSText>
          <ODSText marginTop={6} type={'sm'}>
            {comments}
          </ODSText>

          <ODSText marginTop={16} type={'button'}>
            Last update:
          </ODSText>
          <ODSText marginBottom={10} marginTop={6} type={'sm'}>
            {lastUpdate}
          </ODSText>
        </View>
      ) : null}
    </React.Fragment>
  );
};
const UploadRef = (props) => {
  const dispatch = useDispatch();
  const [file, setFile] = useState('');
  const [fileName, setFileName] = useState('');
  const [showButton, setButton] = useState(true);
  const [currentTenant, setCurrentTenant] = React.useState({});
  const [referencingDocuments, setReferencingDocuments] = React.useState([]);
  const {colors}=useTheme();
  const themeObj = useTheme().colors;
  const [showModal,setShowModal]=useState(false)


  useEffect(() => {
    if (props.currentTenant) {
      setCurrentTenant(props.currentTenant);
      let documents = props.currentTenant?.open_flow_verifications;
      if (documents && documents.length > 0) {
        documents = documents.filter((document) => {
          return document.type_of_document == 'referencing';
        });
        setReferencingDocuments(documents);
      } else {
        setReferencingDocuments([]);
      }
    }
  }, [props.currentTenant]);

  const modifyDate = (date) => {
    return date.substr(0, 10).split('-').join('/');
  };

  const openReferencingLink = async (url, id) => {
    if (url) {
      window.open(url, '_blank');
    }
  };
  const StatusButton = (type) => {
    if (type === "COMPLETED") {
        return 'Completed';
    } else if (type=="NOT STARTED") {
        return 'Not Started';
    } else if (type=="IN PROGRESS") {
        return 'Pending';
    } else if (type=="ACTION REQUIRED") {
        return 'Action Required';
    } else if (type == 6) {
        return 'In Progress';
    } else {
        return 'Pending';
    }
};

  const renderDetailsCard = () => {
    return (
      <View style={{ paddingHorizontal: layoutType == 'phone' ? 10 : 20 }}>
       <ODSBadges restStyle={{ alignSelf: 'flex-end' ,marginTop:12}} type={StatusButton(props?.status)}>
           {StatusButton(props?.status)}
         </ODSBadges>
        <ODSText marginTop={10} type={'h5'}>
          Full Reference
        </ODSText>
        <ODSText marginTop={10} type={'sm'}>
        Please find below information related to you tenancy reference.
        </ODSText>
        <View>
        <ODSText marginTop={24} type={'md-bold'}>
              Reference Handler:
            </ODSText>
            <ODSText marginTop={6} type={'md'}>
            {props?.latestUpdate?.handlerName ? props?.latestUpdate?.handlerName : null}
            </ODSText>
        </View>
        <View style={{flexDirection:'row',justifyContent:'space-between',marginBottom:24}}>
        <View>
        <ODSText marginTop={12} type={'md-bold'}>
              Tel:
            </ODSText>
            <ODSText marginTop={6} type={'md'}>
            {props?.latestUpdate?.handlerContactNumber ? props?.latestUpdate?.handlerContactNumber : null}
            </ODSText>
        </View>
        <View>
        <ODSText marginTop={12} type={'md-bold'}>
              Ref:
            </ODSText>
            <ODSText marginTop={6} type={'md'}>
            {props?.ref_id}
            </ODSText>
        </View>
        </View>
        <AccordianCard
          title={'Employment'}
          status={
            props?.latestUpdate?.creditSearch?.status
              ? props?.latestUpdate?.creditSearch?.status
              : 'Not Started'
          }
          comments={
            props?.latestUpdate?.creditSearch?.comments
              ? props?.latestUpdate?.creditSearch?.comments
              : 'N/A'
          }
          lastUpdate={
            props?.latestUpdate?.currentEmployment?.last_updated
              ? moment(props?.latestUpdate?.currentEmployment?.last_updated).format('Do MMM YYYY')
              : 'N/A'
          }
        />
        <AccordianCard
          title={'Credit Search'}
          status={
            props?.latestUpdate?.creditSearch?.status
              ? props?.latestUpdate?.creditSearch?.status
              : 'Not Started'
          }
          comments={
            props?.latestUpdate?.creditSearch?.comments
              ? props?.latestUpdate?.creditSearch?.comments
              : 'N/A'
          }
          lastUpdate={
            props?.latestUpdate?.creditSearch?.last_updated
              ? moment(props?.latestUpdate?.creditSearch?.last_updated).format('Do MMM YYYY')
              : 'N/A'
          }
        />
        <AccordianCard
          title={'Living Status'}
          status={
            props?.latestUpdate?.currentLiving?.status
              ? props?.latestUpdate?.currentLiving?.status
              : 'Not Started'
          }
          comments={
            props?.latestUpdate?.currentLiving?.comments
              ? props?.latestUpdate?.currentLiving?.comments
              : 'N/A'
          }
          lastUpdate={
            props?.latestUpdate?.currentLiving?.last_updated
              ? moment(props?.latestUpdate?.currentLiving?.last_updated).format('Do MMM YYYY')
              : 'N/A'
          }
        />
        <AccordianCard
          title={'Tenant Search'}
          status={
            props?.latestUpdate?.tenantSearch?.status
              ? props?.latestUpdate?.tenantSearch?.status
              : 'Not Started'
          }
          comments={
            props?.latestUpdate?.tenantSearch?.comments
              ? props?.latestUpdate?.tenantSearch?.comments
              : 'N/A'
          }
          lastUpdate={
            props?.latestUpdate?.tenantSearch?.last_updated
              ? moment(props?.latestUpdate?.tenantSearch?.last_updated).format('Do MMM YYYY')
              : 'N/A'
          }
        />
      </View>
    );
  };
  const openUrl = (url) => {
    if (url) {
      Linking.canOpenURL(url).then((supported) => {
        if (supported) {
          if (url) {
            let ext = url.split('.').reverse()[0];
            if (ext === 'pdf') {
              window.open(
                // 'https://docs.google.com/viewerng/viewer?url='+
                url,
                '_blank'
              );
            } else {
              window.open(url, '_blank');
            }
          }
        } else {
        }
      });
    }
  };
  console.log(props.requestedDocs,'TEst')
  const renderUploadDocs = () => {
    return (
      <View style={{ paddingHorizontal: layoutType == 'phone' ? 10 : 20 }}>
        <ODSText marginTop={10} type={'h5'}>
          Upload docs
        </ODSText>

        <View style={{ flexDirection: 'column' }}>
          <View style={{ flex: 'none' }}>
            <ODSText marginTop={10} type={'button'}>
              Tenant Reference Company
            </ODSText>

            <ODSText marginTop={10} type={'sm'}>
              In this section you can submit document directly to the{' '}
              <ODSText color="#FC4850" type={'sm'}>
                tenant reference company ONLY.
              </ODSText>
            </ODSText>

            <ODSText marginTop={10} type={'button'}>
              Please note:{' '}
              <ODSText type={'sm'}>
                If you have been asked by the Agent to submit documentation, DO NOT use this
                section, please use the section Marked - "Letting Agent"
              </ODSText>
            </ODSText>
          </View>
          <View style={{ flex: 'none' }}>
            <View
              style={{
                marginTop: 10,
                flexDirection: 'column',
                marginBottom: 20,
              }}
            >
              {props?.requestedDocs && props?.requestedDocs.length ? (
                props?.requestedDocs?.map((e, index) => (
                  <RequestDocs
                    item={e}
                    index={index}
                    width={'100%'}
                    fcc={true}
                    fcc_applicant_id={props?.applicant_id}
                    tenant={currentTenant}
                    branch={props?.branch}
                    docLength={props?.requestedDocs?.length}
                    refreshApi={() => {
                      props?.onRefresh();
                    }}
                  />
                ))
              ) : (
                <ODSText type={'sm'}>
                  Upload boxes will appear here once fcc requests a document
                </ODSText>
              )}
            </View>
          </View>
        </View>
        
      </View>
    );
  };
  const renderOpenBankingRequest=()=>{
    return(
      <BoxShadow style={{ alignSelf: 'center',marginTop:20 }} tWidth={'70%'} wWidth={'620px'} bottom={'10px'} right={'0px'}>
      <>
        <ODSText color={colors.text.primary} style={{ alignSelf: 'center' }} type={'h5'}>
        Open Banking Request
        </ODSText>
        <ODSText color={colors.text.primary} marginTop={20} style={{ alignSelf: 'center' }} type={'md-bold'}>
        Tenant Reference Company
        </ODSText>
        <ODSText
          color={themeObj.neutral[700]}
          marginTop={14}
          style={{ alignSelf: 'center' }}
          type={'md'}
        >Your reference company has made a request for open banking to facilitate the reference process.
        </ODSText>
        <ODSText
          color={themeObj.neutral[700]}
          marginTop={10}
          style={{ alignSelf: 'center' }}
          type={'md'}
        >
          For more information about Open Banking please<TouchableOpacity onPress={()=>setShowModal(true)}> <ODSText
color={themeObj.neutral[700]}
style={{ alignSelf: 'center' }}
type={'md-bold'}

> click here</ODSText></TouchableOpacity>

        </ODSText>
        <ODSButton
                  lIcon={'TB-Arrow-Right'}
                  themeColor={themeObj.main.green}
                  restStyle={{ marginTop: 20, alignSelf:'center' }}
                  type="primary"
                  disabled={false}
                  onPress={() => window.open(props?.openbankingURL,"_blank")}
                >
                 Start Open Banking
                </ODSButton>
      </>
  </BoxShadow>
    )
  }

  return (
    <MainSection
      style={{
        flexDirection: layoutType == 'phone' ? 'column' : 'row',
        justifyContent: 'space-between',
        marginTop:0
      }}
    >
      <View style={layoutType == 'phone' ? { width: '100%' } : { flex: 0.48 }}>
        <BoxShadow style={{ padding: 10 }}>{renderDetailsCard()}</BoxShadow>
        {props?.openbankingURL&&renderOpenBankingRequest()}
      </View>
      <View style={layoutType == 'phone' ? { flex: 1, marginTop: 26 } : { flex: 0.48 }}>
        <BoxShadow style={{ padding: 10 }}>{renderUploadDocs()}</BoxShadow>
      </View>
      <ODSModal
          visible={showModal}
          backdropOpacity={0}
          onBackdropPress={() => setShowModal(false)}
        >
          <View
            style={{
              width: layoutType == 'phone' ? '95%' : '60%',
              height: layoutType == 'phone' && 680,
              alignSelf: 'center',
              backgroundColor: 'white',
              padding: 24,
              borderRadius: 12,
              shadowColor: '#101828',
              shadowOffset: { width: 0, height: 1 },
              shadowOpacity: 0.1,
              shadowRadius: 4,
              elevation: 2,
            }}
          >
      <>
      <TouchableOpacity style={{ alignSelf: 'flex-end' }} onPress={() => setShowModal(false)}>
                            <ODSIcon size={24} icon="TB-Close" />
                        </TouchableOpacity>
        <ODSText color={colors.text.primary} style={{ alignSelf: 'center' }} type={'h5'}>
        Open Banking
        </ODSText>
        <ODSText
          color={themeObj.neutral[700]}
          marginTop={14}
          style={{ alignSelf: 'center' }}
          type={'sm'}
        >{`To verify your income and as an alternative to uploading bank statements you can give us access to open banking as a secure expedient way of enabling you to provide your up to date financial data instantly in regards to your tenancy application.
What is Open Banking? Open Banking through FCC Paragon will speed up the process of your tenant referencing. It’s safe, secure, and instant and therefore will help to avoid delays.

Sharing a snapshot of your current financial account history is the same as providing bank statements to us to assess, only easier, faster and safer. This will enable us to verify your income and transactions.

You don’t have to manually upload your bank statements/digital copies saving you time and hassle, and at the same time, it can be done anywhere you have your mobile device with you.

Once you have consented the data is instantly available to FCC Paragon to access and assess in relation to your tenancy application.

Can you trust the service? Simply put, yes you can. FCC Paragon is licensed with Consents.Online an Equifax company to carry out such checks and are also registered with the ICO and the FCA as a regulated company. Consents.Online an Equifax company is licenced and authorised by the FCA (Financial Conduct Authority).`}
        </ODSText>
      </> 
          </View>
        </ODSModal>
     
    </MainSection>
  );
};
export default UploadRef;
